import React from "react";

// External
import styled from "@emotion/styled";

const Container = styled.div`
  position: fixed;
  z-index: -25;
  top: 180px;
  margin: 0 0 0 12vw;
`;

const Moon = () => {
  return (
    <Container>
      <svg
        width="65px"
        height="65px"
        viewBox="0 0 65 65"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            id="worldOrg_dots"
            transform="translate(-169.000000, -4070.000000)"
          >
            <g id="Group-7" transform="translate(169.000000, 4070.000000)">
              <circle
                id="crater-2"
                fill="#F4F4F4"
                cx="32.5"
                cy="32.5"
                r="32.5"
              />
              <path
                d="M17.787251,3.5131565 C14.7509223,8.45614401 13,14.2735971 13,20.5 C13,38.4492544 27.5507456,53 45.5,53 C50.7955211,53 55.7952321,51.7334865 60.212749,49.4868435 C54.4960565,58.7933258 44.2228515,65 32.5,65 C14.5507456,65 1.42108547e-14,50.4492544 1.42108547e-14,32.5 C1.42108547e-14,19.8462667 7.23152305,8.88154619 17.787251,3.5131565 Z"
                id="Combined-Shape"
                fill-opacity="0.75"
                fill="#D8D8D8"
              />
              <ellipse
                id="body"
                fill="#DFDFDF"
                transform="translate(48.198997, 44.716721) rotate(-285.000000) translate(-48.198997, -44.716721) "
                cx="48.1989972"
                cy="44.7167211"
                rx="3.9"
                ry="4.76666667"
              />
              <ellipse
                id="body-copy"
                fill="#DFDFDF"
                transform="translate(56.798997, 34.950054) rotate(-345.000000) translate(-56.798997, -34.950054) "
                cx="56.7989972"
                cy="34.9500545"
                rx="2.5"
                ry="3"
              />
              <ellipse
                id="crater-1"
                fill-opacity="0.5"
                fill="#CBCBCB"
                transform="translate(28.500000, 16.000000) rotate(-334.000000) translate(-28.500000, -16.000000) "
                cx="28.5"
                cy="16"
                rx="9.5"
                ry="12"
              />
            </g>
          </g>
        </g>
      </svg>
    </Container>
  );
};

export default Moon;
